import { useNavigate } from "react-router-dom";
import { LEGAL } from "@/lib/legal";

const SECTIONS = [
  {
    id: "ownership",
    title: "ملكيّة المحتوى",
    body: (
      <>
        <p>
          جميع العناصر المعروضة داخل تطبيق «{LEGAL.app_name_ar}» — بما في ذلك ولكن
          دون حصر:
        </p>
        <ul className="about-list">
          <li>المحتوى التعليميّ والدروس والشروحات.</li>
          <li>الأمثلة البلاغيّة والتمارين والاختبارات.</li>
          <li>التصاميم البصريّة والواجهات والرسومات.</li>
          <li>الشعار «ب» والهويّة البصريّة للعلامة التجاريّة.</li>
          <li>اسم «{LEGAL.app_name_ar}» وما يُشتقّ منه من علاماتٍ تجاريّة.</li>
          <li>الخوارزميّات وأنظمة التقييم بالذكاء الاصطناعيّ.</li>
        </ul>
        <p>
          هذه العناصر جميعًا <strong>ملكٌ خالصٌ لِـ {LEGAL.entity_ar}
          ({LEGAL.entity_en}) — السجلّ التجاريّ رقم {LEGAL.cr_number}</strong> — ومحميّةٌ
          بموجب قوانين حقوق المؤلّف والملكيّة الفكريّة والعلامات التجاريّة
          السارية محلّيًّا ودوليًّا.
        </p>
      </>
    ),
  },
  {
    id: "prohibited",
    title: "الاستخدامات المحظورة",
    body: (
      <>
        <p>
          يُحظَر — دون الحصول على إذنٍ خطّيٍّ مُسبَق من إدارة بَلاغة —
          القيام بأيٍّ ممّا يلي:
        </p>
        <ul className="about-list">
          <li>
            <strong>إعادة الإنتاج:</strong> نسخ أيّ جزءٍ من المحتوى بأيّ وسيلةٍ
            ميكانيكيّةٍ أو إلكترونيّةٍ أو يدويّة.
          </li>
          <li>
            <strong>إعادة التوزيع:</strong> نشر أو إرسال أو رفع المحتوى
            على منصّاتٍ أخرى — تعليميّةٍ كانت أم ترفيهيّة — أو على وسائل
            التواصل الاجتماعيّ بشكل تجاريّ.
          </li>
          <li>
            <strong>الاستخدام التجاريّ:</strong> استخدام أيّ جزءٍ من
            المحتوى أو الهويّة في منتجاتٍ مأجورة، أو لتحقيق ربحٍ بأيّ
            شكلٍ من الأشكال.
          </li>
          <li>
            <strong>التعديل والاشتقاق:</strong> تعديل المحتوى أو ترجمته
            أو اشتقاق أعمالٍ منه دون إذن.
          </li>
          <li>
            <strong>إزالة العلامات:</strong> حذف أو إخفاء أيّ إشاراتٍ تتعلّق
            بحقوق المؤلّف أو الملكيّة الفكريّة.
          </li>
          <li>
            <strong>الهندسة العكسيّة:</strong> محاولة استخراج كود
            التطبيق أو نماذج الذكاء الاصطناعيّ المُستخدَمة.
          </li>
        </ul>
      </>
    ),
  },
  {
    id: "allowed",
    title: "الاستخدامات المسموح بها",
    body: (
      <>
        <p>يحقّ للمستخدم — لأغراضٍ غير تجاريّة وضمن نطاقه الشخصيّ — أن:</p>
        <ul className="about-list">
          <li>يستفيد من الدروس والمحتوى لتطوير مهاراته اللغويّة.</li>
          <li>
            يقتبس أمثلةً قصيرة لأغراضٍ تعليميّةٍ أو نقديّة، مع الإشارة
            الواضحة إلى «بَلاغة» كمصدر.
          </li>
          <li>
            يُشارك رابط التطبيق أو شارات إنجازاته على وسائل التواصل
            الاجتماعيّ.
          </li>
        </ul>
      </>
    ),
  },
  {
    id: "permission",
    title: "طلب الإذن للاستخدام المؤسّسي",
    body: (
      <>
        <p>
          نُرحّب بطلبات الاستخدام المؤسّسي والشراكات التعليميّة من
          الجهات الراغبة في توظيف محتوى «{LEGAL.app_name_ar}» في برامجها الرسميّة،
          بشرط الحصول على إذنٍ خطّيٍّ مُسبَق من {LEGAL.entity_ar}.
        </p>
        <p>
          يُرجى مراسلتنا على البريد الإلكترونيّ:{" "}
          <a
            href={`mailto:${LEGAL.email}`}
            className="legal-link"
            data-testid="ip-contact-email"
            dir="ltr"
          >
            {LEGAL.email}
          </a>{" "}
          مع تفاصيل الاستخدام المطلوب.
        </p>
      </>
    ),
  },
  {
    id: "violations",
    title: "إجراءات في حال الانتهاك",
    body: (
      <>
        <p>
          أيّ انتهاكٍ لحقوق الملكيّة الفكريّة لتطبيق «بَلاغة» قد يُعرّض
          المُنتهك إلى:
        </p>
        <ul className="about-list">
          <li>إنذارٍ رسميّ بإيقاف الاستخدام المخالف فورًا.</li>
          <li>تعليق حسابه في التطبيق دون إشعارٍ مسبق.</li>
          <li>المساءلة القانونيّة وفقًا للأنظمة السارية.</li>
          <li>المطالبة بتعويضٍ ماديّ ومعنويّ عن الأضرار.</li>
        </ul>
        <p>
          إن لاحظتَ انتهاكًا لحقوقنا في أيّ مكان، يُرجى إبلاغنا فورًا عبر
          البريد الإلكترونيّ أعلاه.
        </p>
      </>
    ),
  },
  {
    id: "third-party",
    title: "محتوى الأطراف الثالثة",
    body: (
      <p>
        يتضمّن التطبيق إشاراتٍ إلى نماذج ذكاءٍ اصطناعيّ وخدماتٍ خارجيّة
        (مثل مصادقة جوجل ونماذج اللغة). جميع هذه الخدمات تخصّ أصحابها،
        ولا ندّعي أيّ ملكيّةٍ لها. تخضع تلك الخدمات لشروط الاستخدام
        الخاصّة بها.
      </p>
    ),
  },
];

export default function IPNoticePage() {
  const navigate = useNavigate();
  return (
    <div className="shell has-bottom-nav legal-page" data-testid="ip-page">
      <div className="page-header legal-hero">
        <div className="legal-badge">إشعار قانونيّ</div>
        <h1 data-testid="ip-title">
          الملكيّة <span className="gold">الفكريّة</span>
        </h1>
        <p>
          جميع حقوق التطبيق ومحتواه محفوظة لمشروع «بَلاغة». نُشاركك
          هنا تفاصيل ما يجوز وما لا يجوز فعله بهذا المحتوى.
        </p>
        <div className="legal-meta" data-testid="ip-updated">
          آخر تحديث: {LEGAL.last_updated}
        </div>
      </div>

      {SECTIONS.map((s) => (
        <section
          key={s.id}
          className="about-section legal-section"
          data-testid={`ip-section-${s.id}`}
        >
          <h2>{s.title}</h2>
          <div className="legal-body">{s.body}</div>
        </section>
      ))}

      <div className="about-cta">
        <button
          className="btn btn-primary"
          onClick={() => navigate("/")}
          data-testid="ip-back-btn"
          style={{ padding: "12px 24px" }}
        >
          العودة إلى الرئيسيّة
        </button>
        <button
          className="btn btn-ghost"
          onClick={() => navigate("/terms")}
          data-testid="ip-to-terms"
        >
          شروط الاستخدام
        </button>
      </div>
    </div>
  );
}
